<template>
  <detail-page :breadcrumb="false">
    <template #content>
      <div class="content">
        <div class="text">
          <div>找不到指定内容(╥╯^╰╥)</div>
          <div><span @click="back">返回主页</span></div>
        </div>
      </div>
    </template>
  </detail-page>
</template>

<script>
import DetailPage from '@/views/pc/components/detailPage/Index.vue'

export default {
  name: 'Pc404',
  components: {
    DetailPage,
  },
  methods: {
    back() {
      this.$router.push({ name: 'PcHome' })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin: 0 auto;
  padding-top: 50px;
  width: 1000px;

  .text {
    display: flex;
    flex-direction: column;
    text-align: center;
    font-size: 30px;
    color: #515151;

    div {
      display: block;
      margin-bottom: 10px;
    }

    span {
      font-size: 24px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>